import { setAccessToken } from '@driftt/web-auth'

export const setupDevAuth = (): void => {
  // These are set by dotenv, not by electron.
  const token = process.env.DRIFT_APP_TOKEN
  if (token) {
    setAccessToken({ token })
  }
}

export const INVALID_USER = 'InvalidUser'
export const AUTHORIZATION_ERROR = 'AuthorizationFailure'
